import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogType } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { ColumnTable } from 'src/app/models/column-table';
import { Filter } from 'src/app/models/filter';
import { FilterTable } from 'src/app/models/filter-table';
import { VoidPaymentFilter } from 'src/app/models/filters/void-payment-filter';
import { Paging } from 'src/app/models/page';
import { VoidPaymentRequest } from 'src/app/models/request/void-payment-request';
import { VoidPayment } from 'src/app/models/void-payment';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { LoanService } from 'src/app/services/loan.service';
import { ReportService } from 'src/app/services/report.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-void-payment-list',
  templateUrl: './void-payment-list.component.html',
  styleUrls: ['./void-payment-list.component.sass']
})
export class VoidPaymentListComponent implements OnInit {

  constructor(private loanService: LoanService, private confirmService: PosConfirmationService, private configService: ConfigurationService, private toastrService: ToastrService, private reportService: ReportService, private authService: AuthService) { }

  payments: Paging<Array<VoidPayment>> = new Paging([]);
  filter: Filter<VoidPaymentFilter> = { page: 0, pageSize: 10, value: {} };
  async ngOnInit(): Promise<void> {
    await this.getVoidPayments(this.filter);
  }

  getVoidPaymentsTable(): Array<ColumnTable> {
    return [
      new ColumnTable("documents", "Documentos", { wordWrap: true }),
      new ColumnTable("contracts", "Contratos", { wordWrap: true }),
      new ColumnTable("customerCode", "Código de Cliente"),
      new ColumnTable("customerName", "Nombre de Cliente"),
      new ColumnTable("amount", "Total", { type: "currency" }),
      new ColumnTable("date", "Fecha", { type: "date" }),
      new ColumnTable("status", "Estado", { type: 'badge', valueMap: this.getStatusMap() }),
      new ColumnTable("documents", "Opciones", {
        type: "action",
        actions: [
          {
            icon: "fa fa-ban text-danger",
            fn: async (payment: VoidPayment) => {
              await this.createVoidPayment(payment);
            },
            disabledFn: (payment: VoidPayment) => { return payment.returnReceipt != undefined && payment.returnReceipt.length > 0; },
            tooltip: "Anular",
            isDisabled: false,
            isPrivileged: true,
            privilege: "doVoidPayment"
          },
          {
            icon: "fa fa-regular fa-file-pdf text-success",
            fn: async (payment: VoidPayment) => {
              this.reportService.printReport(await this.reportService.receiptPdf(payment.receiptCode).toPromise());
            },
            tooltip: "Reimprimir Recibo",
            isDisabled: false
          },
          {
            icon: "fa fa-print text-warning",
            fn: async (payment: VoidPayment) => {
              this.reportService.printReport(await this.reportService.rollbackReceiptPdf(payment.returnReceipt, payment.groupingNo, this.configService.readSelectedBranchAndSalesOrg().salesOrg.code, this.configService.readSelectedBranchAndSalesOrg().branch.code, this.authService.readProfileInStorage().username, true, false).toPromise())
            },
            tooltip: "Reimprimir Devolucion",
            isDisabled: true,
            disabledFn: (payment: VoidPayment) => { return payment.returnReceipt == undefined; },
          },

        ],
        iconClass: 'fa fa-cogs',
        isIcon: true
      })
    ];
  }
  async createVoidPayment(payment: VoidPayment) {

    let result = await this.confirmService.showAsync("¡Advertencia!", `¿Está seguro de querer anular este pago con la siguiente información?
  No. Documentos: ${payment.documents} 
  Contratos: ${payment.contracts} 
  Cliente: ${payment.customerCode} - ${payment.customerName} 
  Total: ${payment.amount}`, ModalDialogType.WARNING);

    if (result) {
      const request = new VoidPaymentRequest();

      request.details.push(...payment.details.map(m => {
        return {
          document: [m.documentNumber],
          contractNumber: m.contractNumber,
          salesOrg: m.contractSalesOrg,
          groupingNo: payment.groupingNo
        }
      }));
      request.invoiceCode = payment.invoiceCode;
      request.createInvoice = true;
      request.customerCode = payment.customerCode;
      request.branchCode = this.configService.readSelectedBranchAndSalesOrg().branch.code;
      request.salesOrgCode = this.configService.readSelectedBranchAndSalesOrg().salesOrg.code;
      request.amount = payment.amount;
      const result = await this.loanService.createVoidPayment(request).toPromise();
      if (result.code == 200) {
        Swal.fire({
          title: `Anulación de Pagos`,
          html: `Se ha anulado el pago con éxito </br> ${request.invoiceCode ?? ""} ${request.details.flatMap(f => f.contractNumber + ' ')}`,
          icon: 'success',
          confirmButtonText: 'Aceptar',
        });
        await this.getVoidPayments(this.filter);
        const p = this.payments.content.find(f => f.documents.includes(payment.documents)) ?? new VoidPayment();
        if (p.returnReceipt && p.groupingNo) {
          this.reportService.printReport(await this.reportService.rollbackReceiptPdf(p.returnReceipt, p.groupingNo, this.configService.readSelectedBranchAndSalesOrg().salesOrg.code, this.configService.readSelectedBranchAndSalesOrg().branch.code, this.authService.readProfileInStorage().username, true, false).toPromise())
        }

      }
    }
  }

  getVoidPaymentsFilter(): Array<FilterTable> {
    return [
      new FilterTable("documents", "Documento"),
      new FilterTable("contracts", "Contrato"),
      new FilterTable("customerCode", "Código de Cliente"),
    ];
  }

  async getVoidPayments(params: Filter<VoidPaymentFilter>) {
    this.payments = (await this.loanService.getVoidPayments(params).toPromise()).response || new Paging([]);
    this.filter = params;
  }

  getStatusMap() {
    const result = new Map<string, string>();

    result.set("PAYED", "Pagado");
    result.set("RETURN", "Devuelto");

    return result;
  }
}
